import React from 'react';

const orderSteps = [
  {
    number: '01',
    icon: '/images/how-to-order/step-link.png',
    title: 'Отправляете ссылку',
    text: 'Ссылка, размер, цвет, цена',
  },
  {
    number: '02',
    icon: '/images/how-to-order/step-calculation.png',
    title: 'Получаете расчет',
    text: 'Проверяем наличие и рассчитываем стоимость',
  },
  {
    number: '03',
    icon: '/images/how-to-order/step-confirm-payment.png',
    title: 'Подтверждаете и оплачиваете выкуп',
    text: 'Подскажем по стоимости, срокам и оформлению заказа.',
  },
  {
    number: '04',
    icon: '/images/how-to-order/step-package.png',
    title: 'Получаете заказ',
    text: 'Получаете заказ удобным способом',
  },
];

const Product = () => {
  return (
    <section className="container order-process-section">
      <div className="order-process-head">
        <div className="order-process-title">
          <p className="order-process-kicker">Выкуп под заказ</p>
          <h2>Как сделать заказ</h2>
        </div>

        <p className="order-process-intro">
          Нашли товар на официальном сайте, в аутлете или на распродаже?
          Отправьте ссылку — рассчитаем стоимость, выкупим заказ и организуем доставку.
        </p>
      </div>

      <div className="order-process-steps order-process-steps-route">
        <svg
          className="order-process-route-line"
          viewBox="0 0 1000 120"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            className="order-process-route-path"
            d="M 90 62 C 190 18, 250 104, 350 62 S 510 20, 620 62 S 780 104, 910 62"
          />
          <circle className="order-process-route-dot" cx="285" cy="62" r="8" />
          <circle className="order-process-route-dot" cx="500" cy="62" r="8" />
          <circle className="order-process-route-dot" cx="715" cy="62" r="8" />
        </svg>

        <svg
          className="order-process-route-line-tablet"
          viewBox="0 0 1000 420"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            className="order-process-route-path"
            d="M 170 92 C 310 38, 430 146, 560 92 S 760 38, 830 92"
          />
          <circle className="order-process-route-dot" cx="500" cy="92" r="8" />

          <path
            className="order-process-route-path"
            d="M 170 318 C 310 264, 430 372, 560 318 S 760 264, 830 318"
          />
          <circle className="order-process-route-dot" cx="500" cy="318" r="8" />
        </svg>

        {orderSteps.map((step) => (
          <article className="order-process-card" key={step.number}>
            <div className="order-process-image-wrap">
              <img
                className="order-process-image"
                src={process.env.PUBLIC_URL + step.icon}
                alt=""
                loading="lazy"
                decoding="async"
              />
            </div>

            <div className="order-process-copy">
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="order-process-actions">
        <a
          className="order-process-btn order-process-btn-primary"
          href="https://t.me/Shoptopbuyer"
          target="_blank"
          rel="noreferrer"
        >
          Написать в Telegram
        </a>

        <a
          className="order-process-btn order-process-btn-secondary"
          href="https://max.ru/u/f9LHodD0cOJjibeQdLaN1HkU7twja89JfpuGsU8p2lFu6TOKe4IPrrruCrA"
          target="_blank"
          rel="noreferrer"
        >
          Написать в MAX
        </a>
      </div>
    </section>
  );
};

export default Product;
